import React, { ReactElement } from 'react';
import JoinUsFormLayout from 'components/join-us/form-layout/join-us-form-layout';

import './join-us-thanks.scss';

interface JoinUsThanksProps {
    onClose: () => void;
}

const JoinUsThanks: React.FC<JoinUsThanksProps> = ({ onClose }): ReactElement => (
    <JoinUsFormLayout footerButtonLabel="Zamknij" footerButtonOnClick={onClose}>
        <div className="join-us-thanks">
            <strong>
                Dziękujemy za zgłoszenie
            </strong>
            <p>
                Twoje zgłoszenie zostanie rozpatrzone.
            </p>
        </div>
    </JoinUsFormLayout>
);

export default JoinUsThanks;
